import React from 'react'

import {
  EuiTitle,
  EuiSpacer,
  EuiFlexGroup,
  EuiHorizontalRule
} from '@elastic/eui'

import IntroCards from './alarmCGIToC'

export default function IntroHome() {

  return (
    <React.Fragment>
      <EuiSpacer />
        <EuiTitle size="m">
            <h1>720p Serie CGI List :: Alarm Menu</h1>
        </EuiTitle>
        <EuiHorizontalRule margin="xs" />
      <EuiFlexGroup gutterSize="l" direction="column" style={{margin: '0 7px'}} >
          <IntroCards />
    </EuiFlexGroup>
  </React.Fragment>
  );
}
